import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useValuesChartsDataContext } from './hooks/useValuesChartsDataContext';

export const WithoutIncentivesAnual = () => {
    const { chartData } = useValuesChartsDataContext();

    return (
        <SimpleBars
            title={'Valor Calculado Sem Incentivos (Anual)'}
            horizontal={false}
            subtitles={chartData?.withoutIncentivesAnual?.map((item) => getYearLabel(item.ano))}
            values={chartData?.withoutIncentivesAnual?.map((item) => item.value || 0)}
        />
    );
};
